import { Star, Award } from "lucide-react";
import {
  Carousel,
  CarouselContent,
  CarouselItem,
} from "@/components/ui/carousel";
import Autoplay from "embla-carousel-autoplay";
import partner1 from "@/assets/partner-1.webp";
import partner2 from "@/assets/partner-2.webp";
import partner3 from "@/assets/partner-3.webp";

const partners = [
  { logo: partner1, name: "Brillux" },
  { logo: partner2, name: "Sto" },
  { logo: partner3, name: "Caparol" },
];

export const TrustBar = () => {
  return (
    <section className="py-8 bg-muted/30 border-y border-foreground/5">
      <div className="container mx-auto">
        <div className="flex flex-col lg:flex-row items-center gap-8 lg:gap-12">
          {/* Trust Signals */}
          <div className="flex flex-wrap items-center justify-center gap-6 lg:gap-8 shrink-0">
            <div className="flex items-center gap-2 px-4 py-2 bg-foreground/5 rounded-md">
              <Award className="w-4 h-4 text-foreground" />
              <span className="text-xs font-semibold tracking-wide uppercase text-foreground">Malermeisterbetrieb</span>
            </div>
            <div className="flex items-center gap-2 px-4 py-2 bg-foreground/5 rounded-md">
              <div className="flex items-center gap-0.5">
                {[...Array(5)].map((_, i) => (
                  <Star key={i} className="w-3 h-3 fill-yellow-500 text-yellow-500" />
                ))}
              </div>
              <span className="text-xs font-semibold text-foreground">4.7 / 5 Google (25 Rezensionen)</span>
            </div>
          </div>

          {/* Divider */}
          <div className="hidden lg:block w-px h-8 bg-foreground/10" />

          {/* Partner Logos */}
          <div className="flex-1 w-full lg:w-auto overflow-hidden">
            <Carousel
              opts={{ align: "start", loop: true }}
              plugins={[Autoplay({ delay: 2500 })]}
              className="w-full"
            >
              <CarouselContent>
                {partners.map((partner, index) => (
                  <CarouselItem key={index} className="basis-1/2 md:basis-1/3 lg:basis-1/4">
                    <div className="flex items-center justify-center h-16 px-4">
                      <img
                        src={partner.logo}
                        alt={`Partner ${partner.name}`}
                        className="max-h-14 max-w-full object-contain grayscale opacity-50 hover:grayscale-0 hover:opacity-100 transition-all duration-500"
                      />
                    </div>
                  </CarouselItem>
                ))}
              </CarouselContent>
            </Carousel>
          </div>
        </div>
      </div>
    </section>
  );
};
